import type { RouteRecordRaw } from "vue-router"

const defaultBookId = "informatika"
const defaultBookPath = `/10kl/${defaultBookId}`
const defaultReadPath = `${defaultBookPath}/read/page/5`

export const commonRoutes: RouteRecordRaw[] = [
        { path: "/5kl/istoriya-nashego-kraya-moskva/read/page/:pageNumber", name: "moscow-history-read", component: () => import("@/window/ReadPage.vue"), meta: { label: "Read Book", bookId: "istoriya-nashego-kraya-moskva", navPath: "/5kl/istoriya-nashego-kraya-moskva/read/page/1" } },
        { path: "/10kl/:bookId/read/page/:pageNumber", name: "read", component: () => import("@/window/ReadPage.vue"), meta: { label: "Read Book", navPath: defaultReadPath } },
        { path: "/read/:chapterId/:sectionId", redirect: defaultBookPath },
        { path: "/native-validation", name: "native-validation", component: () => import("@/admin/NativeValidationPage.vue"), meta: { label: "Native Validation" } },
]
